"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.Actions = void 0;
const xstate_1 = require("xstate");
const utils_1 = require("../utils");
const assertEventType_1 = require("./assertEventType");
const events_1 = require("./events");
const constants_1 = require("../constants");
var Actions;
(function (Actions) {
    Actions["SET_CONFIG"] = "@action/SET_CONFIG";
    Actions["SET_INCOMING_CONFIG"] = "@action/SET_INCOMING_CONFIG";
    Actions["SET_TYPEAHEAD_TERMS"] = "@action/SET_TYPEAHEAD_TERMS";
    Actions["SET_TYPEAHEAD_SUGGESTIONS"] = "@action/SET_TYPEAHEAD_SUGGESTIONS";
    Actions["SET_LOCATION"] = "@action/SET_LOCATION";
    Actions["SET_STATE"] = "@action/SET_STATE";
    Actions["SET_LOGGER"] = "@action/SET_LOGGER";
    Actions["SET_PREVIEW_TYPEAHEAD_SUGGESTIONS"] = "@action/SET_PREVIEW_TYPEAHEAD_SUGGESTIONS";
    Actions["SET_API_START_TIME"] = "@action/SET_API_START_TIME";
})(Actions = exports.Actions || (exports.Actions = {}));
exports.actions = {
    [Actions.SET_CONFIG]: (0, xstate_1.assign)({
        config: (_, event) => {
            (0, assertEventType_1.assertEventType)(event, events_1.Events.DONE_FILL_IN_CONFIG_DEFAULTS);
            return event.data;
        }
    }),
    [Actions.SET_INCOMING_CONFIG]: (0, xstate_1.assign)({
        serverConfig: (_, event) => {
            (0, assertEventType_1.assertEventType)(event, events_1.Events.DONE_FETCH_CONFIG);
            return event.data;
        }
    }),
    [Actions.SET_TYPEAHEAD_TERMS]: (0, xstate_1.assign)({
        typeaheadTerms: (_, event) => {
            (0, assertEventType_1.assertEventType)(event, events_1.Events.SEND_TYPEAHEAD_TERMS);
            return event.data;
        }
    }),
    [Actions.SET_TYPEAHEAD_SUGGESTIONS]: (0, xstate_1.assign)({
        typeaheadSuggestions: (_, event) => {
            (0, assertEventType_1.assertEventType)(event, events_1.Events.DONE_FETCH_TYPEAHEAD);
            return event.data;
        },
        apiResponseTime: (context) => {
            // track the API response times, start time is set when we transition to FETCHING
            if (context.apiRequestTimestamp) {
                return Date.now() - context.apiRequestTimestamp;
            }
            else {
                return undefined;
            }
        }
    }),
    [Actions.SET_LOCATION]: (0, xstate_1.assign)({
        location: (_, event) => {
            (0, assertEventType_1.assertEventType)(event, events_1.Events.SEND_LOCATION);
            return event.data;
        }
    }),
    [Actions.SET_STATE]: (0, xstate_1.assign)((context, event) => {
        var _a, _b;
        (0, assertEventType_1.assertEventType)(event, events_1.Events.INITIALIZE_STATE);
        return Object.assign(Object.assign({}, context), { typeaheadTerms: (_a = event.data) === null || _a === void 0 ? void 0 : _a.typeaheadTerms, location: (_b = event.data) === null || _b === void 0 ? void 0 : _b.location });
    }),
    [Actions.SET_LOGGER]: (0, xstate_1.assign)({
        log: (_, event) => {
            (0, assertEventType_1.assertEventType)(event, events_1.Events.DONE_INITIALIZE_LOGGING);
            return event.data;
        }
    }),
    [Actions.SET_PREVIEW_TYPEAHEAD_SUGGESTIONS]: (0, xstate_1.assign)({
        typeaheadSuggestions: (context) => {
            const { config } = context;
            if (config) {
                // appease TS, can't get this far without a config
                return (0, utils_1.buildFormattedSuggestions)(config, constants_1.previewTypeaheadResponse, 'https://foo.com');
            }
            else {
                // this is just for the preview widget, so doesn't matter, but shouldn't happen
                return [];
            }
        }
    }),
    [Actions.SET_API_START_TIME]: (0, xstate_1.assign)({
        apiRequestTimestamp: () => {
            return Date.now();
        }
    })
};
//# sourceMappingURL=actions.js.map